import moment from "moment";

export const FormatDateFirstDayYear = (): string => {
  const yearCurrency = moment().year() - 1;

  const firstDayYear = moment(`${yearCurrency}-01-01`).format("YYYY-MM-DD");

  return firstDayYear;
};
